import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plumbing',
  templateUrl: './plumbing.component.html',
  styleUrls: ['./plumbing.component.scss']
})
export class PlumbingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
